
    import {computed, ComputedRef, defineComponent, reactive, watch} from 'vue'
    import {useStore} from "@/store";
    import {useRoute} from "vue-router";

    interface TitleData {
        text: string;
        icon: string;
        clickFun: string;
    } 

    interface State {
        isNoDefect: ComputedRef<boolean>; // 是否为无火烧无泡水无重大事故的车
        point: ComputedRef<"N" | "Y">; // N 没有三种缺陷 Y 有三种缺陷
        isAccident: number; // 0不是事故车 1是事故车
        isFire: number; // 0不是事故车 1是事故车
        isWater: number; // 0不是事故车 1是事故车
        reportCode: string | null; 
        isCeilingLamp: ComputedRef<boolean>;
        isActive: boolean;
        opacityStyle: number;
        clickData: object;
        isShowModel: boolean;
        bgCol: string;
        channelType: string; // 家选 承诺100天
        reportLevel: number;
    }

    export default defineComponent({
        name: "headTip",
        setup() {
            let state: State = reactive({
                isNoDefect: false as any,
                point: "N" as any,
                isAccident: 1,
                isFire: 1,
                isWater: 1,
                reportCode: '',
                isCeilingLamp: false as any,
                isActive: false,
                opacityStyle: 0,
                bgCol:'#ffffff',
                isShowModel: false,
                clickData: {},
                channelType: '',
                reportLevel: 0,
            })
            const {query} = useRoute();
            let store = useStore();
            let dataInfo: ComputedRef<{}> = computed<{}>(() => store.state.dataInfo)
            let isDisplay: ComputedRef<{}> = computed<{}>(() => store.state.isDisplay)
            let opacityStyle: ComputedRef<{}> = computed<{}>(() => store.state.opacityStyle)
            watch([dataInfo, isDisplay, opacityStyle],(data: any) => {
                const {isAccident, isFire, isWater} = data[0]
                const {isDisplay} = data[1]
                const {opacityStyle} = data[2]
                state.reportCode = `${query.reportCode}`;
                state.channelType = `${query.channelType}` || '';
                state.reportLevel = Number(`${query.reportLevel}`) || 0;
                state.isNoDefect = computed(() => {
                    return isAccident === 0 && isFire === 0 && isWater === 0
                })
                state.point = computed(() => {
                    return state.isNoDefect ? 'N' : 'Y'
                })
                state.isAccident = isAccident
                state.isFire = isFire
                state.isWater = isWater
                state.isCeilingLamp = computed(() => {
                    return isAccident === 0 && isFire === 0 && isWater === 0 && isDisplay
                })
                state.isActive = (opacityStyle && opacityStyle > 0.5) ? true : false
                if (opacityStyle) {
                    state.opacityStyle = opacityStyle
                } else {
                    state.opacityStyle = 0
                }
            })
            return {
                state
            }
        },
        methods: {}
    })
